// TODO traducir exito erro a español y nombre interface
export enum IconEnum {
  Exito = 'check',
  Error = 'error',
  Advertencia = 'advertencia',
  Informacion = 'informacion',
  Personalizado = 'personalizado',
  SinIcono = 'sinicono',
}
